import styled from 'styled-components'
import { typoHeading6, typoLabel } from '../../../../lib/styles/Typography'

export const Styled = {
  Title: styled.h3`
    margin-bottom: 1rem;
  `,
  List: styled.ul`
    display: grid;
    gap: 0.5rem;
    margin: 0;
    padding: 0;
  `,
  Item: styled.li`
    align-items: center;
    display: flex;
    gap: 2rem;
  `,
  Content: styled.div`
    flex: 1 1 auto;
  `,
  DownloadButton: styled.button`
    align-items: center;
    appearance: none;
    background: none;
    border: none;
    color: var(--c-theme-invert);
    cursor: pointer;
    display: flex;
    flex: 0 0 auto;
    height: 2rem;
    justify-content: center;
    line-height: 1;
    margin: 0;
    padding: 0;
    padding: 0.5rem;
    width: 2rem;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 0.25rem;
    }
  `,
  ItemTitle: styled.h4`
    ${typoHeading6}
  `,
  ItemDetails: styled.div`
    align-items: center;
    display: flex;
    gap: 0.2rem;
    margin-top: 0.25rem;
  `,
  ItemDetail: styled.div`
    &:not(:first-child):before {
      content: '·';
      margin-right: 0.2rem;
    }

    ${typoLabel}
    color: var(--c-theme-invert);
    opacity: 0.4;
  `,
}
